module.exports = __webpack_public_path__ + "static/images/components/VehicleType/images/mediumTank.732f9327.png";


//////////////////
// WEBPACK FOOTER
// ./components/VehicleType/images/mediumTank.png
// module id = 2728
// module chunks = 11